import { ConfigService } from '@services/webFeeder/config.service';
import { Injectable } from '@angular/core';
import {  MatDialog } from '@angular/material/dialog';
import { Constants } from '@utils/constants';
import { SidebarService } from '@services/sidebar.service';
import { Subscription , of } from 'rxjs';
import { WorkspaceNewService } from '@services/workspace-new.service';
import { BilletModalFloatComponent } from '@component/billet-modal-float/billet-modal-float.component';
import { ConnectTypeUperEnum } from '@model/enum/connect-type-user.enum';
import { MatBottomSheet } from '@angular/material/bottom-sheet';

@Injectable({
  providedIn: 'root'
})
export class BilletOrderModalService {

  private flagOptions = false;
  private symbolAsset: string;
  public billetTypeTemp: any;
  public quoteTemp: any;
  public tabSendTemp: number;
  public clickOpenTabOrder: Subscription;
  public modalBuySell: any;
  dialog: MatDialog;

  constructor(
    private buySell: MatBottomSheet,
    private _sidebarService: SidebarService,
    private _configService: ConfigService,
    private workspaceService: WorkspaceNewService,
    dialog: MatDialog,
  ) {
    this.dialog = dialog;
    this.clickOpenTabOrder = this._sidebarService.clickOpenTabAuth$
      .subscribe(tab => {
        if (tab === 5) {
          this.buySellOrder(this.billetTypeTemp, this.quoteTemp);
        }
      });
  }

  buySellOrder(billetType: string, quote?: string, price?: string, tabSend?: string, qtd?: number): void {
    if (!this._configService.isLoginMarketData()) {
      const userWks = this.workspaceService.getUserWorkspaces();
      if (userWks && userWks.length > 0 && userWks[0].Id) {
        if (billetType) {
          this.billetTypeTemp = billetType.toUpperCase();
        }
        this.quoteTemp = quote;
        if (Number(this._configService.getBrokerAccountType()) === ConnectTypeUperEnum.HB_TYPE_MARKET_DATA) {
          this._configService.systemNotificationMessage('', Constants.BROKER_SIDE_BAR_OFFLINE, Constants.ALERT_TYPE.info);
        } else if (!this._configService.isAuthenticationBroker()) {
          this._sidebarService._clickOpenTabLoginBroker.next(true);
          this._sidebarService._clickOpenTabAuthCallBack.next(5);
        } else if (this._configService.isAuthenticationBroker()) {
          const element = document.getElementById('btn-buy');
          if (billetType && element) {
            const position = element.getBoundingClientRect();
            // TODO: Componente 'BuySellModalComponent' contém a boleta do Footer
            this.modalBuySell = this.dialog.open(BilletModalFloatComponent, {
              data: { billetType: this.billetTypeTemp, quote: this.quoteTemp, price: price, qtd },
              position: { top: '50px', left: (position.left - 96) + 'px' },
              minHeight: '487px',
              width: '304px',
              panelClass: 'no-scroll-x',
              autoFocus: false,
              disableClose: true,
            });
          }
        }
      } else {
        this.workspaceService.updateShowMessageToAddWks(true);
      }
    }
  }

  flagVerify() {
    if (this.flagOptions) {
      return true;
    } else {
      return false;
    }
  }
}
